export type UserContextOrganization = {
  id: string;
  name: string;
};

export type UserContextProject = {
  id: string;
  name: string;
};

export type UserContext = {
  userId: string | null;
  organization: string | null;
  organizations: UserContextOrganization[];
  projectId: string | null;
  projects: UserContextProject[];
  roles: string[];
  permissions: string[];
};

let _userContext: UserContext | null;

export const initUserContext = (
  userContext: Omit<UserContext, "projects" | "organizations"> & {
    projects?: UserContextProject[];
    organizations?: UserContextOrganization[];
  }
) => {
  _userContext = {
    ...userContext,
    organizations: [...(userContext.organizations ?? [])],
    projects: [...(userContext.projects ?? [])],
    roles: [...userContext.roles],
    permissions: [...userContext.permissions],
  };
};

export const getUserContext = (): UserContext => {
  if (!_userContext) {
    throw new Error("Uninitialized user context");
  }
  return _userContext;
};
